/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".released-notes[_ngcontent-%COMP%]{max-height:70vh;overflow:auto}.version-text[_ngcontent-%COMP%]{margin-left:-16vh;font-size:x-small;vertical-align:bottom;color:#a9a9a9}"];
export { styles as styles };
